<template>
  <div class="container container-table">
      <div class="row vertical-10p">
        <div class="container">
          <img src="/static/img/nidin_long_logo.png" class="center-block logo">
          <p class="text-center text-black">後台管理系統</p>
          <div class="text-center col-md-4 col-md-offset-4">
            <!-- login form -->
            <form class="ui form loginForm"  @submit.prevent="checkInput">
              <div class="input-group">
                <span class="input-group-addon p-y-0"><i class="fa fa-user"></i></span>
                <input class="form-control h-55" name="account" placeholder="帳號" type="text" v-model="account" maxlength="45" autocomplete="account">
              </div>
              <div class="input-group">
                <span class="input-group-addon p-y-0"><i class="fa fa-lock"></i></span>
                <input class="form-control h-55" name="password" placeholder="密碼" type="password" v-model="password" autocomplete="password">
              </div>
              <br>
              <button type="submit" class="btn-blue" :class="'btn btn-primary btn-lg ' + loading">登入</button>
            </form>

            <!-- errors -->
            <div v-if=response class="text-red"><p>{{response}}</p></div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
var sha256 = require('js-sha256').sha256
import { mapActions, mapGetters } from 'vuex'
import store from '../store'
import config from '../assets/js/handle-config.js'
import { getSharedToken } from '../assets/js/shared-token.js'

// 檢查是否為安全的 redirect 網址
function isSafeRedirect (path) {
  // 排除不安全的 redirect
  if (typeof path !== 'string' || !/^\/(?!\/)/.test(path)) return false
  // 登入頁本身會自己導自己；根路徑會蓋掉照 roleType 決定首頁的邏輯
  return path !== '/' && !path.startsWith('/login')
}

// 沒有 redirect 的首頁
function defaultPath (roleType) {
  return parseInt(roleType, 10) === 50 ? '/mqttTable' : '/dashboard'
}

export default {
  name: 'Login',
  beforeRouteEnter (to, from, next) {
    // 驗證失敗的情況下，留在登入頁
    const isLogin = getSharedToken() || window.localStorage.getItem(config.token)
    if (!isLogin || store.state.authError) {
      next()
      return
    }
    // 有 cookie 或 localStorage 的 token：直接跳轉到 redirect 的頁面，沒有 redirect 時就跳到預設首頁。
    const redirect = to.query.redirect
    if (isSafeRedirect(redirect)) next(redirect)
    else next(defaultPath(store.state.roleType || window.localStorage.getItem(config.roleType)))
  },
  data (router) {
    return {
      section: 'Login',
      loading: '',
      account: '',
      password: '',
      response: ''
    }
  },
  computed: {
    ...mapGetters(['getUserId', 'getToken']),
    getData () {
      return this.$parent.getData
    },
    setLStorage () {
      return this.$parent.setLStorage
    },
    randomString () {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz'
      // max = 16, min = 8
      var stringLength = Math.random() * (16 - 8) + 8
      var randomS = ''
      for (var i = 0; i < stringLength; i++) {
        var rNum = Math.floor(Math.random() * chars.length)
        randomS += chars.substring(rNum, rNum + 1)
      }
      return randomS
    }
  },
  methods: {
    ...mapActions(['setUserInfo', 'setAuthError']),
    checkInput () {
      if (!this.account) {
        this.$notify({
          title: '帳號為空',
          text: '請輸入帳號，進行登入',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else if (!this.password) {
        this.$notify({
          title: '密碼為空',
          text: '請輸入密碼，進行登入',
          duration: 3000,
          type: 'danger',
          width: 400
        })
      } else {
        this.clickLogin()
      }
    },
    clickLogin () {
      var data = {
        account: this.account,
        password: sha256(this.password),
        device_id: 'NIDINPanelWeb_' + this.randomString
      }
      var url = '/auth/login'
      this.getData('post', url, data, (response) => {
        if (response.data.status === 200) {
          const userId = response.data.user_id
          const token = response.data.token
          const roleType = response.data.role_type
          const account = data.account
          this.setUserInfo({userId, token, roleType, account})
          this.setLStorage(this.$config.userId, userId)
          this.setLStorage(this.$config.account, data.account)
          this.setLStorage(this.$config.token, token)
          this.setLStorage(this.$config.roleType, roleType)
          const redirect = this.$route.query.redirect
          if (isSafeRedirect(redirect)) this.$router.push(redirect)
          else this.$router.push(defaultPath(roleType))
        }
      })
    },
    toggleLoading () {
      this.loading = (this.loading === '') ? 'loading' : ''
    },
    resetResponse () {
      this.response = ''
    }
  },
  created () {
    // 後端沒回應被導過來的：訊息顯示在表單上，並清掉免得殘留到下一次進登入頁
    if (this.$store.state.authError) {
      this.response = this.$store.state.authError
      this.setAuthError('')
    }
  }
}
</script>

<style>
html, body, .container-table {
  height: 100%;
}
.container-table {
    display: table;
    color: white;
}
.vertical-center-row {
    display: table-cell;
    vertical-align: middle;
}
.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.logo {
  width: 25em;
  padding: 2em;
}
.loginForm .input-group {
  padding-bottom: 1em;
  height: 3.3em;
}
.loginForm .input-group input {
  height: 3.2em;
}
</style>
<style lang="sass" scoped>
  .p-y-0
    padding-top: 0px !important
    padding-bottom: 0px !important
  .h-55
    height: 55px !important
  .notification-wrapper
    top: 5px !important
  .logo
    max-width: 250px
  @media screen and (max-width: 767px)
    .logo
      max-width: 220px
  .container-table
    width: 100vw
    padding: 0px
    .row
      width: 100vw
</style>



// WEBPACK FOOTER //
// Login.vue?e44bc17a